import axios from 'axios';
import { triggerLogout } from './authEvents';

const baseURL = process.env.REACT_APP_API_BASE || 'http://localhost:8000';

const axiosInstance = axios.create({
  baseURL,
});

// Attach Authorization header from localStorage before each request
axiosInstance.interceptors.request.use((config) => {
  try {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers = config.headers || {};
      // Do not override explicitly set Authorization headers
      if (!config.headers['Authorization'] && !config.headers['authorization']) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
    }
  } catch (_e) {
    // ignore storage access errors
  }
  return config;
});

// Handle 401 responses - trigger logout for authentication failures
let isLoggingOut = false;

// Reset logout flag after a delay to allow logout to complete
const resetLogoutFlag = () => {
  setTimeout(() => {
    isLoggingOut = false;
  }, 1000);
};

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // If we get a 401 (Unauthorized), check if it's an authentication error
    if (error?.response?.status === 401 && !isLoggingOut) {
      const config = error?.config || {};
      const hasAuthHeader = config.headers?.['Authorization'] || config.headers?.['authorization'];
      const url = config.url || '';
      
      // DATEV endpoints might return 401 for connection issues, not auth failures
      // Never logout on 401 for DATEV endpoints - they indicate DATEV is not connected,
      // not that the user's session is invalid
      const isDatevEndpoint = url.includes('/datev/');
      
      // For DATEV endpoints, never logout on 401 (they handle errors gracefully)
      // For other endpoints with auth header, logout on any 401
      if (hasAuthHeader && !isDatevEndpoint) {
        // Non-DATEV endpoints: logout on 401 (likely auth failure)
        if (window.location.pathname !== '/login' && window.location.pathname !== '/signup') {
          isLoggingOut = true;
          triggerLogout();
          resetLogoutFlag();
        }
      }
      // DATEV endpoints: silently ignore 401 errors (they just mean DATEV is not connected)
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
export { baseURL };

// [
//     "https://admintools.nbg1.your-objectstorage.com/users/cmfo5b9430000nlapeyhftz0q/jobs/2025/09/20/164648/guid1.pdf",
//     "https://admintools.nbg1.your-objectstorage.com/users/cmfo5b9430000nlapeyhftz0q/jobs/2025/09/20/164648/guid2.pdf",
//     "https://admintools.nbg1.your-objectstorage.com/users/cmfo5b9430000nlapeyhftz0q/jobs/2025/09/20/164648/guid3.pdf",
//     "https://admintools.nbg1.your-objectstorage.com/users/cmfo5b9430000nlapeyhftz0q/jobs/2025/09/20/164648/guid4.pdf",
//     "https://admintools.nbg1.your-objectstorage.com/users/cmfo5b9430000nlapeyhftz0q/jobs/2025/09/20/164648/guid5.pdf"
// ]